module.exports = __webpack_public_path__ + "img/type-one-to-one.985b97c7.svg";